import { getGraphQueryRequestV2 } from '../../../../../data/daoFunctions/GraphQueries/recursiveFilteredGraphQuery';
import { getAscendingGroupRecuriveQuery } from '@iotv/datamodel-core';
const debug = process.env.REACT_APP_DEBUG && false;
export const getGroupHierarchy = async ({ item, groupDefiningObjectTypeId }) => {
    const { contextObjects, topLevelQuery } = getAscendingGroupRecuriveQuery({ groupDefiningObjectTypeId, item });
    const res = await getGraphQueryRequestV2({ contextObjects: [item], query: topLevelQuery });
    debug && console.log(`getGroupHierarchy res`, res);
    return res;
};
